export default __webpack_public_path__ + "static/media/visible.4d189353.svg";